import { useState, useEffect } from 'react'
import { X } from 'lucide-react'
import { NewsletterForm } from './NewsletterForm'
import { trackEvent } from '../utils/analytics'

export function NewsletterPopup() {
  const [isVisible, setIsVisible] = useState(false)
  const [hasInteracted, setHasInteracted] = useState(false)

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('hasSeenNewsletterPopup')
    if (hasSeenPopup) return

    const handleMouseLeave = (e: MouseEvent) => {
      if (!hasInteracted && e.clientY <= 0) {
        setIsVisible(true)
        setHasInteracted(true)
        localStorage.setItem('hasSeenNewsletterPopup', 'true')
        trackEvent('newsletter_popup_shown', {
          trigger: 'mouse_leave',
          timestamp: new Date().toISOString()
        })
      }
    }

    document.addEventListener('mouseleave', handleMouseLeave)
    return () => document.removeEventListener('mouseleave', handleMouseLeave)
  }, [hasInteracted])

  const handleClose = () => {
    setIsVisible(false)
    trackEvent('newsletter_popup_closed', {
      timestamp: new Date().toISOString()
    })
  }

  if (!isVisible) return null

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fade-in">
      <div className="relative max-w-lg w-full bg-gray-950 border border-gray-800 rounded-2xl p-8 text-center shadow-xl">
        <button
          onClick={handleClose}
          className="absolute -top-2 -right-2 w-8 h-8 bg-gray-800 rounded-full shadow-lg flex items-center justify-center hover:bg-gray-700 transition-colors"
          aria-label="Close popup"
        >
          <X className="w-4 h-4 text-gray-400" />
        </button>

        <h2 className="text-2xl font-bold mb-2 text-yellow-300">
          Want Funded Trading Shortcuts?
        </h2>

        <p className="text-sm text-gray-400 mb-6">
          Join 1,000+ smart traders getting real tips, real deals & real edge.
        </p>

        <NewsletterForm source="exit_popup" variant="default" />

        <p className="text-xs text-gray-500 mt-4">
          No spam. Just trading edge.
        </p>
      </div>
    </div>
  )
}

export default NewsletterPopup
